import React from 'react';
import './ProgressSteps.scss';

const steps = [
  { label: 'Step 1' },
  { label: 'Step 2' },
  { label: 'Step 3' },
  { label: 'Step 4' },
  { label: 'Step 5' },
];

const ProgressSteps = ({ completed = 0 }) => {
  const completedWidth = `${(completed / (steps.length - 1)) * 100}%`;

  return (
    <div className='bordure'>
    <div className="progress-steps">
      <div className="progress-container">
        
        <div className="completed-connector" style={{ width: completedWidth }}></div> {/* Green line for completed steps */}
        {steps.map((step, index) => (
          <div className={`step ${index < completed ? 'completed' : ''} ${index === completed ? 'active' : ''}`} key={index}>
            <div className="step-number">{index + 1}</div>   {/*pour les cercle en gris*/}
            <div className="step-label">{step.label }</div>   {/*pour la couleur des ecris des steps*/}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default ProgressSteps;
